export default {
  // Общие элементы
  common: {
    loading: "Жүктелуде...",
    save: "Сақтау",
    cancel: "Бас тарту",
    edit: "Өңдеу",
    delete: "Жою",
    search: "Іздеу",
    close: "Жабу",
    back: "Артқа",
    next: "Келесі",
    previous: "Алдыңғы",
    submit: "Жіберу",
    confirm: "Растау",
    yes: "Иә",
    no: "Жоқ",
    all: "Барлығы",
    rating: "Рейтинг",
    services: "Қызметтер",
    hajj: "Қажылық",
    umra: "Умра",
  },

  // Навигация
  navigation: {
    home: "Басты бет",
    about: "Біз туралы",
    news: "Жаңалықтар",
    article: "Мақала",
    qa: "Сұрақ-жауап",
    tours: "Турлар",
    other: "Басқа",
    contacts: "Байланыс",
    profile: "Профиль",
    login: "Кіру",
    register: "Тіркелу",
    logout: "Шығу",
  },

  // Заголовки
  headers: {
    logoTitle: "Қазақстан қажылары",
    logoSubtitle: "Hajj.kz",
  },

  // Меню
  menu: {
    home: "Басты бет",
    about: "Біз туралы",
    news: "Жаңалықтар",
    contacts: "Байланыс",
    profile: "Профиль",
    liveStreaming: "Тікелей эфир",
    sendPrayer: "Дұға жіберу",
  },

  // Языки
  languages: {
    kk: "Қаз",
    ru: "Рус",
    en: "Eng",
  },

  // Регионы
  regions: {
    astana: "Астана",
    almaty: "Алматы",
    shymkent: "Шымкент",
    aktobe: "Ақтөбе",
    karaganda: "Қарағанды",
    taraz: "Тараз",
    pavlodar: "Павлодар",
    oskemen: "Өскемен",
    semey: "Семей",
    atyrau: "Атырау",
    uralsk: "Орал",
    kyzylorda: "Қызылорда",
    aktau: "Ақтау",
    petropavl: "Петропавл",
    kokshetau: "Көкшетау",
    taldykorgan: "Талдықорған",
  },

  // Время намаза
  prayerTimes: {
    fajr: "Таң",
    sunrise: "Күн",
    dhuhr: "Бесін",
    asr: "Екінті",
    maghrib: "Ақшам",
    isha: "Құптан",
  },

  // Формы
  forms: {
    email: "Электрондық пошта",
    password: "Құпия сөз",
    confirmPassword: "Құпия сөзді растау",
    firstName: "Аты",
    lastName: "Тегі",
    phone: "Телефон",
    city: "Қала",
    region: "Аймақ",
    address: "Мекенжай",
    birthDate: "Туған күні",
    passportNumber: "Паспорт нөмірі",
    required: "Міндетті өріс",
    invalidEmail: "Жарамсыз электрондық пошта",
    passwordMismatch: "Құпия сөздер сәйкес емес",
    fullName: "Аты жөні",
    phonePlaceholder: "+7 (___) ___-__-__",
    phoneError: "Телефон нөмірін дұрыс енгізіңіз",
  },

  // Сообщения
  messages: {
    success: "Сәтті орындалды",
    error: "Қате орын алды",
    warning: "Ескерту",
    info: "Ақпарат",
    saved: "Сақталды",
    deleted: "Жойылды",
    updated: "Жаңартылды",
    languageChanged: "Жаңа тіл қолданылуы үшін бет қайта құрылады",
  },

  // Аутентификация
  auth: {
    welcome: "Қош келдіңіз!",
    connectToSystem: "Жүйеге қосылыңыз",
    loginTitle: "Жүйеге кіру",
    registerTitle: "Тіркелу",
    forgotPassword: "Құпия сөзді ұмыттыңыз ба?",
    rememberMe: "Мені есте сақтау",
    loginButton: "Кіру",
    registerButton: "Тіркелу",
    resetPassword: "Құпия сөзді қалпына келтіру",
    alreadyHaveAccount: "Аккаунтыңыз бар ма?",
    dontHaveAccount: "Аккаунтыңыз жоқ па?",
    loginSuccess: "Сәтті кірдіңіз",
    registerSuccess: "Сәтті тіркелдіңіз",
    logoutSuccess: "Сәтті шықтыңыз",
    registerSuccessTitle: "Сәтті тіркелдіңіз!",
    registerSuccessDescription: "Жүйеге кіру үшін логин мен құпия сөз жазыңыз.",
    loginButtonText: "Кіру",
  },

  // Профиль
  profile: {
    personalInfo: "Жеке ақпарат",
    orders: "Тапсырыстар",
    settings: "Баптаулар",
    changePassword: "Құпия сөзді өзгерту",
    editProfile: "Профильді өңдеу",
    saveChanges: "Өзгерістерді сақтау",
    personalCabinet: "Жеке кабинет",
    editPersonalInfo: "Жеке ақпаратты өңдеу",
    fullName: "Аты жөні",
    fullNamePlaceholder: "Аты жөніңізді енгізіңіз",
    emailPlaceholder: "E-mail енгізіңіз",
    removeEmail: "E-mail жою",
    save: "Сақтау",
    saving: "Сақталуда...",
    noOrders: "Өтінімдеріңіз жоқ",
    orderDate: "Өтінім күні",
    pilgrimName: "Паломник аты",
    status: "Күй",
    statusPublished: "Жарияланды",
    statusModeration: "Модерацияда",
    statusAccepted: "Өтініміңіз қабылданды! Сіз қажылар базасында тіркелдіңіз.",
    statusPending:
      "Тексеруден өтуде. Өтінім қабылданған соң сіздің профиліңіз базада жарияланады.",
    logout: "Жүйеден шығу",
  },

  // Хадж
  hajj: {
    title: "Қажылық",
    mission: "Миссия",
    register: "Тіркелу",
    search: "Іздеу",
    holyPlaces: "Қасиетті орындар",
    tourOperators: "Туроператорлар",
    news: "Жаңалықтар",
    videos: "Бейнелер",
    photos: "Фотосуреттер",
    books: "Кітаптар",
    hajjis: "Қажылар",
    hajjisList: "Қажылар тізімі",
    hajjUmra: "Қажылық және Ұмра",
    tourCompanies: "Туристік компаниялар",
    hajjMission: "Қазақстан қажылық миссиясы",
    hajjRegistration: "Қазақстан қажыларын тіркеу базасы",
    registeredHajjis: "Тіркелген қажылар",
    hajjYear: "Қажылық жасаған жылы",
    selectRegion: "Аймақты таңдаңыз:",
    searchHajjis: "Қажыларды іздеу",
    searchSubtitle: "Аты жөніңізді, аймақты таңдап іздеу",
    fullName: "Аты жөні",
    selectYear: "Қажылық жасаған жылы",
    hajjDate: "Қажылыққа барған жылы",
    hajjUntil: "Қажылыққа дейін",
    hajjDateText: "Қажылық {day} {month} {year}ж",
    hajjYearText: "Қажылыққа барған жылы",
    age: "Жасы",
    region: "Аймағы",
    biography: "Өмірбаяны",
    impressions: "Қажылықтан алған әсері",
    advice: "Қажыларға кеңес",
    hajjAccepted: "Қажылығыңыз қабыл болсын!",
    amin: "Әумин!",
    dua: "Маған дұға жасаңыз",
    duaDescription:
      "Сіз өз атыңыздан немесе жақындарыңыздың атынан дұға жолдай аласыз. Алла Тағала барлық дұға-тілектеріңізді қабыл етсін!",
    sendDua: "Дұға жолдау",
    searchByName: "Аты жөнімен іздеу",
    new: "Жаңа",
    old: "Ескі",
    sampleDuaText:
      "Аллахумма инни ас'алука мин хайри ма са'аляка минху набийюка Мухаммадун саллаллаху алейхи ва саллям, ва а'узу бика мин шарри маста'аза минху набийюка Мухаммадун саллаллаху алейхи ва саллям.",
    authorName: "Ахметов Азамат",
    authorDetails: "Қажылық жасаған жылы: 2024",
    hajjiMadeDua: "қажы дұға жасады",
    noDua: "Дұға жоқ",
    duaForm: {
      title: "Дұға жолдау",
      subtitle:
        "Cіз өзіңіз немесе жақындарыңыз үшін дұға сұрай аласыз. Алла әр дұғаны қабыл етсін!",
      region: "Өңірі",
      duaType: "Дұға түрі",
      duaText: "Дұға мәтіні (міндетті)",
      duaTextPlaceholder:
        "Өзіңіздің дұға сұрауыңызды жазыңыз... (мысалы: «Әпкем Салтанаттың денсаулығына дұға сұраймын...»)",
      submitButton: "Дұға жолдау",
      submitting: "Жіберілуде...",
      fillAllFields: "Барлық мәліметтерді толтырыңыз",
      successTitle: "Дұға өтінішіңіз сәтті қабылданды!",
      successDescription:
        "Модерациядан өткен соң сайтта жарияланады. Алла ниетіңізді қабыл етсін!",
      closeButton: "Жабу",
      sendAnotherButton: "Тағы бір дұға жіберу",
    },
    duaActions: {
      noDuaYet:
        "Әзірге бұл ниетке ешбір қажы дұға жасамады. Алғашқы болып шын жүректен дұға жасап, сауапты іске үлес қосыңыз!",
      makeDua: "Дұға жасау",
      duaLiked: "Дұғаңыз сәтті жіберілді!",
      youMadeDua: "Сіз дұға жасап қойдыңыз",
    },
    months: {
      january: "қаңтар",
      february: "ақпан",
      march: "наурыз",
      april: "сәуір",
      may: "мамыр",
      june: "маусым",
      july: "шілде",
      august: "тамыз",
      september: "қыркүйек",
      october: "қазан",
      november: "қараша",
      december: "желтоқсан",
    },
  },

  // Медиа
  media: {
    title: "Медиа",
    articles: "Мақалалар",
    qa: "Сұрақ-жауаптар",
    videoSection: "Бейнероликтер",
    photoGallery: "Фотогалерея",
    library: "Кітапхана",
    goToQa: "Сұрақ-жауаптарға өту",
    goToNews: "Жаңалықтарға өту",
    moreDetails: "Толығырақ",
    videoContent: "Видеоконтент",
    videos: "Бейнероликтер",
    photos: "Фотогалерея",
    books: "Кітапхана",
    author: "Автор",
    publisher: "Баспа",
    pages: "Беттер саны",
    year: "Шығарылған жылы",
    shortDescription: "Қысқаша сипаттама",
    read: "Оқу",
    noAdditionalInfo: "Қосымша ақпарат жоқ",
    seeAlso: "Тағы қараңыз",
    share: "Бөлісу",
    linkCopied: "Сілтеме көшірілді",
    copyFailed: "Сілтемені көшіру мүмкін болмады",
    category: "Категория",
    source: "Көз",
    views: "Көрулер",
    date: "Күні",
  },

  // Онлайн трансляция
  liveStreaming: {
    title: "Онлайн трансляция",
    liveStream: "тікелей эфир",
    mekke: "Мекке",
    medina: "Медина",
  },

  // Футер
  footer: {
    contact: "Байланыс",
    address: "Мекенжай",
    phone: "Телефон",
    email: "Электрондық пошта",
    social: "Әлеуметтік желілер",
    copyright: "Авторлық құқық",
    allRightsReserved: "Барлық құқықтар қорғалған",
    addressValue: "Астана қаласы, Қарасаз к-сi, 3",
    phoneValue: "+ 7 (7172) 999 387",
    registered: "Тіркелген",
    hajji: "қажы",
    applyButton: "Өтінім беру",
    onlineStreaming: "Онлайн трансляция",
  },

  // Статистика
  stats: {
    registered: "Тіркелген",
    hajji: "қажы",
    count: "401",
  },

  // Святые места

  holyPlaces: {
    title: "Қасиетті орындар",
    mecca: "Мекка",
    medina: "Медина",
    meccaDescription: "Исламның ең қасиетті қаласы, Қағба орналасқан орын.",
    medinaDescription:
      "Мұхаммед пайғамбардың (с.а.у.) хижра жасаған және жерленген жері.",
    all: "Барлығы",
    kaaba: "Қағба (әл-Масжид әл-Харам)",
    kaabaDescription:
      "Қағба — исламдағы ең қасиетті орын. Мұсылмандардың сенімі бойынша, оны Ибраһим (ғ.с.) және ұлы Исмаил (ғ.с.) Алланың бұйрығымен салған. Қағба — мұсылмандардың құбыласы, яғни намаз оқығанда бет бұратын бағыты. Ол исламның бірлігі мен Аллаға деген беріктіктің символы болып табылады.",
    location: "Орналасқан жері: Мекке",
    map: "Карта",
  },

  // Туроператоры
  tourOperators: {
    title: "Туроператорлар",
    rating: "Рейтинг",
    services: "Қызметтер",
    hajj: "Қажылық",
    umra: "Умра",
    serviceType: "Қызмет түрі",
    features: "Ерекшеліктері",
    location: "Орналасқан жері",
    photoGallery: "Фотогалерея",
    links: "Сілтемелер",
    contactNumber: "Байланыс нөмірі",
    logoAlt: "Туроператор логотип",
    evaluation: "Бағалау және пікір қалдыру",
    evaluationText:
      "Туроператордың қызметін бағалау үшін сайтқа кіріңіз немесе тіркеліңіз",
    reviews: "Пікірлер",
    reply: "Жауап",
    companyName: "Атлас Туризм",
    replyText:
      "Азамат, пікіріңізге рахмет! Сізді қайтадан көргенімізге қуаныштымыз.",
    reviewText1:
      "Қажылықта болдым. Жақсы ұйымдастырылған тур. Гидтер мен топ жетекшілері өте көмектесті. Барлығына рахмет!",
    reviewText2: "Өте жақсы тур болды. Келесі жылы да осы компаниямен барамын.",
    userName1: "Гульнара Алиева",
    userName2: "Азамат Сериков",
    viewTours: "Турларды қарау",
  },

  // Статьи
  articles: {
    back: "Артқа",
    share: "Бөлісу",
    seeAlso: "Тағы қараңыз",
    category: "Категория",
    source: "Көз",
  },

  // FAQ
  faq: {
    title: "Сұрақ-жауап",
    goToQa: "Сұрақ-жауаптарға өту",
    loading: "Жүктелуде...",
    error:
      "Деректерді жүктеу кезінде қате орын алды. Кейінірек қайталап көріңіз.",
  },

  // Миссия
  mission: {
    organizeHajj: "Қажылықты ұйымдастыру және қадағалау",
    getQuota: "Қазақстанға арналған қажылық квотасын алу",
    approveOperators: "Қажылықты ұйымдастыратын туроператорларды бекіту",
    monitorRegistration: "Қажыларды тіркеу жүйесін қадағалау",
    religiousAdvice: "Қажыларға діни мәселелер бойынша кеңес беру",
    qualityControl: "Туроператорлардың қызмет сапасын бақылау",
    security: "Қажылардың қауіпсіздігін қамтамасыз ету",
    evaluation: "Қажылық сапарын бағалау және есеп беру",
  },

  // Партнеры
  partners: {
    title: "Біздің серіктестер",
  },

  // Новости
  news: {
    title: "Жаңалықтар",
    goToNews: "Жаңалықтарға өту",
    moreDetails: "Толығырақ",
    latest: "Соңғы жаңалықтар",
  },

  // Выбор региона
  regionSelector: {
    title: "Аймақты таңдаңыз",
    search: "Іздеу",
    back: "Артқа",
  },

  // Пагинация
  pagination: {
    back: "Артқа",
    next: "Келесі",
  },

  // Мобильные приложения
  mobileApps: {
    title: "Qaji Guide",
    subtitle:
      "Қажылық және ұмра өтеушілерге арналған тегін цифрлық көмекші құрал",
  },

  // Время (для CountDown)
  time: {
    days: "күн",
    hours: "сағат",
    minutes: "минут",
    seconds: "секунд",
  },

  // Дополнительные элементы
  additional: {
    addressLabel: "Мекенжайы:",
    phoneLabel: "Телефон:",
    copyrightText: "2025 © Қазақстан қажылары. All rights reserved",
  },

  // Форма паломника
  pilgrimForm: {
    title: "Өтінім беру",
    description:
      "Сіз немесе туысыңыз қажылыққа барған ба? Қазақстан қажылар базасына тіркеліңіз",
    step1Title: "Жеке ақпарат",
    step2Title: "Өмірбаяны",
    step3Title: "Қажылықтан алған әсері",
    step3AdviceTitle: "Қажыларға кеңес",
    fields: {
      lastName: "Тегі",
      firstName: "Аты",
      fatherName: "Әкесінің аты",
      age: "Жасы",
      ageHint: "Қажылыққа неше жасыңызда бардыңыз?",
      region: "Аймағы, елді мекен",
      regionHint: "Мысал: Алматы облысы, Талғар ауданы",
      hajjYear: "Қажылыққа барған жылы",
      iin: "ИИН",
      photo: "Фото жүктеу",
      biography: "Өмірбаяны",
      biographyPlaceholder: "Өмірбаяныңызды жазыңыз",
      biographyHint:
        "Мысалы: туған жері, мамандығы, отбасы, дін жолындағы қызметі",
      impressions: "Қажылықтан алған әсері",
      impressionsPlaceholder: "Қажылықтан алған әсеріңізді жазыңыз",
      impressionsHint:
        "Мысалы: Қажылықта Қағбаны алғаш көрген сәт — өмірімдегі ең ұмытылмас кезең болды",
      advice: "Қажыларға кеңес",
      advicePlaceholder: "Қажыларға кеңесіңізді жазыңыз",
      adviceHint: "Мысал: кеңестер, дайындық, дұға, сабыр, рухани кеңес",
    },
    photoUpload: {
      title: "Фото жүктеу",
      description: "Ихрамдағы немесе ресми жеке суретіңізді жүктеңіз",
      button: "Жүктеу",
      hint: "* Мысалы: паспорт форматы немесе қажылықтағы сурет",
    },
    validation: {
      lastName: "Тегіңізді енгізіңіз",
      firstName: "Атыңызды енгізіңіз",
      age: "Жасыңызды енгізіңіз",
      region: "Аймағы, елді мекенін таңдаңыз",
      hajjYear: "Қажылыққа барған жылын енгізіңіз",
      iin: "ИИНңызды енгізіңіз",
      photo: "Фотоңызды жүктеңіз",
    },
    buttons: {
      next: "Келесі",
      submit: "Өтінімді жіберу",
    },
    messages: {
      success: "Өтініміңіз жіберілді",
      error: "Өтініміңіз жіберілмеді",
    },
  },

  // Туры
  tours: {
    title: "Турлар",
    filter: "Фильтр",
    reset: "Қалпына келтіру",
    priceFrom: "Бастап",
    priceTo: "Дейін",
    duration: "Мерзімі",
    packageType: "Пакет түрін таңдау",
    tourType: "Тур түрі",
    allCities: "Барлық қала",
    orderButton: "Тапсырыс беру",
    moreDetails: "Толығырақ",
    remainingSeats: "Қалған орындар",
    noToursFound: "Сіздің сүзгілеріңізге сәйкес турлар табылмады",
    clearFilters: "Фильтрлерді тазалау",
    loadingError: "Турларды жүктеу кезінде қате пайда болды",
    retry: "Қайталау",
    company: "Фирма",
    tourOperators: "Туроператорлар",
    departureDate: "Кету күні",
    returnDate: "Келу күні",
    directFlight: "тікелей рейс",
    oneTransfer: "1 ауысу",
    transfers: "{count} ауысу",
    medinaIn: "Мединада",
    meccaIn: "Меккеде",
    medinaCity: "Медина",
    meccaCity: "Мекке",
    nights: "түн",
    dayPackage: "күндік пакет",
    // Package types
    econom: "Эконом",
    standart: "Стандарт",
    comfort: "Комфорт",
    lux: "Люкс",
    // Tour types
    all: "Барлығы",
    umra: "Умра",
    hajj: "Хадж",
    // Duration options
    days7: "7 күн",
    days10: "10 күн",
    days14: "14 күн",
    days21: "21 күн",
    days30: "30 күн",
    // Tour detail page
    back: "Артқа",
    aboutPackage: "Пакет жайлы",
    flightTime: "Ұшу уақыты",
    hajjDays: "Қажылық күндері",
    packageIncludes: "Пакетке не кіреді",
    writeManager: "Менеджерге жазу",
    route: "Маршрут",
    outbound: "Бару",
    returnTrip: "Қайту",
    // Hotels
    hotels: "Қонақ үйлер",
    hotelsDescription:
      "Бұл бағдарлама аясында Сіз Мекке және Мединеде төмендегі қонақ үйлерде орналасасыз. Қонақ үйлер деңгейі мен шарттары пакеттің классына (Эконом / Комфорт / Люкс) сәйкес келеді.",
    medinaHotel: "Мединедегі қонақ үй",
    meccaHotel: "Меккедегі қонақ үй",
    distanceToNabawi: "Масжид ән-Набауиға дейінгі қашықтық:",
    distanceToHaram: "əл-Харамға дейінгі қашықтық:",
    onFoot: "жаяу",
    accommodation: "Жайғастыру",
    meals: "Тамақтану",
    nightsCount: "Түндер саны",
    viewGallery: "Галереяны көру",
    detailLoadError: "Тур деталін жүктеу кезінде қате пайда болды",
    // Booking modal
    booking: {
      fullName: "Атыңыз, тегіңіз",
      phone: "Телефон нөміріңіз",
      email: "E-mail",
      consent:
        "Мен жеке деректерімді өңдеуге келісемін. Деректер өтінімді өңдеу, байланысқа шығу және турды рәсімдеу үшін қолданылады. Құпиялылық саясаты —",
      consentLink: "сілтеме.",
      submitting: "Жіберілуде...",
      submit: "Тапсырыс беру",
      successTitle: "Өтініміңіз қабылданды!",
      successText:
        "Біз жақын уақытта сізбен байланысамыз. Менеджер пакет бойынша барлық мәліметті нақтылап шығады.",
      successButton: "Жақсы",
    },
  },

  // О нас
  about: {
    title: "Бұл біз туралы бет",
  },
};
